import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Language } from '../models/language';
import { TRANSLATIONS } from './translations/translations';
import { CONFIG, BASECONFIG } from '../config';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
    private _selectedLanguageId: number;
    private _supportedLangs: Language[] = [];
    

    constructor(@Inject(TRANSLATIONS) private _translations: any,
        private _http: HttpClient) {
        
    }

    public get currentLang() {
        var currentLang = localStorage.getItem('currentLanguage');
        return currentLang;
    }

    public use(lang: string): void {
        localStorage.setItem('currentLanguage', lang);
    }

    public translate(key: string): string {
        let translation = key;
        if (this._translations[this.currentLang] && this._translations[this.currentLang][key]) {
            return this._translations[this.currentLang][key];
        }

        return translation;
    }

    public instant(key: string) {
        return this.translate(key);
    }

    public get selectedLanguageId() {
        switch (this.currentLang) {
            case 'bs':
                this._selectedLanguageId = 1;
                this.checkSelectedLanguage('bs');
                break;
            case 'hr':
                this._selectedLanguageId = 3;
                this.checkSelectedLanguage('hr');
                break;
            case 'sr_cyr':
                this._selectedLanguageId = 2;
                this.checkSelectedLanguage('sr_cyr');
                break;
            default:
                this._selectedLanguageId = 1;  
                this.checkSelectedLanguage('bs');
                break;
        }
        
        return this._selectedLanguageId;
    }

    private checkSelectedLanguage(lang: string) {
        var currentLang = localStorage.getItem('currentLanguage');

        if (!currentLang || currentLang != lang) {
            this.use(lang);
        }
    }


    public getSupportedLanguageList(): Observable<Language[]> {
        let id: number = 0;
        let onlyActive: boolean = true;
        let langID: number = 1;
        return this._http.get<any[]>(CONFIG.baseUrls.shared.getAllLanguagesForDropdown + (id.toString() == null ? 0 : id.toString()) + "/" + onlyActive + "/" + langID.toString())
            .pipe();
    }
    
    public translateByMunicipalityId(key: string) {
        if (BASECONFIG.municipalityId == CONFIG.municipalityEnum.grad_doboj || BASECONFIG.municipalityId == CONFIG.municipalityEnum.grad_gradiska ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.grad_prijedor || BASECONFIG.municipalityId == CONFIG.municipalityEnum.grad_trebinje) {
            return this.instant('grad_rs_' + key);
        } else if (BASECONFIG.municipalityId == CONFIG.municipalityEnum.grad_bihac || BASECONFIG.municipalityId == CONFIG.municipalityEnum.grad_cazin ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.grad_gracanica || BASECONFIG.municipalityId == CONFIG.municipalityEnum.grad_gradacac ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.grad_tuzla || BASECONFIG.municipalityId == CONFIG.municipalityEnum.grad_mostar) {
            return this.instant('grad_fbih_' + key);
        } else if (BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_kostajnica || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_kozarska_dubica ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_prnjavor || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_teslic ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_celinac || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_gacko ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_istocno_novo_sarajevo || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_laktasi ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_mrkonjic_grad || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_samac ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_srbac || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_ljubinje) {
            return this.instant('opstina_rs_' + key);
        } else if (BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_bosanska_krupa || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_kalesija ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_sanski_most || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_tesanj ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_velika_kladusa || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_zepce ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_bosanski_petrovac || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_busovaca ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_buzim || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_capljina ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_citluk || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_doboj_istok ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_ilijas || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_ljubuski ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_odzak || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_orasje ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_siroki_brijeg || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_tomislavgrad ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_vitez || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_trnovo ||
            BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_vogosca || BASECONFIG.municipalityId == CONFIG.municipalityEnum.opstina_kljuc) {
            return this.instant('opstina_fbih_' + key);
        }
    }
}
